import { getTermValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

export const firstFloor: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('is_first_floor')(jsonQuery);
    if (value == null) {
      return null;
    }

    return [
      {
        group: 'firstFloor',
        text: value ? 'Первый этаж' : 'Не первый этаж',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setIsFirstFloor',
      arguments: [null],
    });
  },
};
